module.exports = __webpack_public_path__ + "static/02-obstacles-f0f142c3939372d1c0d8a62b1e30b268.png";